import { Logo } from './Logo';
import { MarketplaceSelector } from './MarketplaceSelector';
import { UserInfo } from './UserInfo';
import HelpMenu from '../../../general/HelpMenu'; // Added HelpMenu for user support
import { DeviceFamilySelector } from '../select/DeviceFamilySelector';
import styles from './Header.module.css';

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.logoSection}>
          <Logo />
        </div>
        <div className={styles.rightSection}>
          <DeviceFamilySelector />
          <MarketplaceSelector />
          <HelpMenu /> {/* Help menu with demo and support options */}
          <UserInfo />
        </div>
      </div>
    </header>
  );
};

export { Header };
